package com.narbase.letsgo.web.models.voiceassistant

import com.narbase.letsgo.dto.EnumDtoName
import com.narbase.letsgo.dto.core.EnumPersistenceName

enum class VoiceAssistantField(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    PICKUP,
    DROPOFF
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantConfidence(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    HIGH,
    MEDIUM,
    LOW
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantOutcome(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    RESOLVED,
    NEEDS_SELECTION,
    TRANSFER_TO_CALL_CENTER
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantEngine(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    OPENAI,
    OPENAI_MCP,
    AI_STANDALONE
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantTransferReason(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    LOW_CONFIDENCE,
    MEDIUM_CONFIDENCE,
    PASSENGER_REQUESTED,
    INTERPRETER_FAILED
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantModelProvider(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    OPENAI,
    OPENAI_COMPATIBLE
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantMediumConfidenceAction(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    CONFIRM_ROUTE,
    OFFER_CALL_CENTER,
    TRANSFER_TO_CALL_CENTER
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantEngineDecisionConfidence(
    val confidence: VoiceAssistantConfidence?,
    persistenceName: String? = null,
    dtoName: String? = null,
) : EnumPersistenceName, EnumDtoName {
    HIGH(VoiceAssistantConfidence.HIGH),
    MEDIUM(VoiceAssistantConfidence.MEDIUM),
    LOW(VoiceAssistantConfidence.LOW),
    FROM_SCORE(null)
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantSpeechDetector(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    SILERO_MODEL,
    LOUDNESS
    ;

    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}

enum class VoiceAssistantModelRole(persistenceName: String? = null, dtoName: String? = null) :
    EnumPersistenceName, EnumDtoName {
    CHAT,
    TRANSCRIPTION
    ;
    override val dtoName = dtoName ?: this.name
    override val persistenceName = persistenceName ?: this.name
}
